import { lehtoCustomizations } from "src/tenantCustomizations/tenants/lehto/lehtoCustomizations";
import { omegakeittiotCustomizations } from "src/tenantCustomizations/tenants/omegakeittiot/omegakeittiotCustomizations";
import { PartialTenantCustomizations } from "src/tenantCustomizations/TenantCustomizations.ts";
import { salvosCustomizations } from "src/tenantCustomizations/tenants/salvos/salvosCustomizations.ts";
import { mellanoCustomizations } from "./tenants/mellano/mellanoCustomizations";
import { hawoCustomizations } from "src/tenantCustomizations/tenants/hawo/hawoCustomizations.ts";
import { puukotiCustomizations } from "src/tenantCustomizations/tenants/puukoti/puukotiCustomizations.ts";
import { demo1Customizations } from "src/tenantCustomizations/tenants/demo1/demo1Customizations.ts";

const realTenantCustomizationValues: Record<string, PartialTenantCustomizations> = {
	demo1: demo1Customizations,
	lehto: lehtoCustomizations,
	omegakeittiot: omegakeittiotCustomizations,
	salvos: salvosCustomizations,
	puukoti: puukotiCustomizations,
	hawo: hawoCustomizations,
	uponor: {},
	mellano: mellanoCustomizations,
	kaskipuu: {},
	lumon: {},
	jloy: {},
} as const;

const devTenant = import.meta.env.VITE_DEV_TENANT;

const devTenantDefaultConfig: PartialTenantCustomizations = {
	tenantConfig: {
		erp: {
			enabled: true,
			salesEnabled: true,
			ledgerIntegrationEnabled: false,
		},
		maps: {
			enabled: true,
		},
	},
} as const;

export const tenantCustomizationValues: Record<string, PartialTenantCustomizations> = {
	...realTenantCustomizationValues,
	localhost:
		devTenant === undefined
			? devTenantDefaultConfig
			: realTenantCustomizationValues[devTenant]!,
} as const;
